<template>
  <div>
    <el-dialog v-model="dialogVisible" width="35rem" :before-close="childDialogClick" center class="d_confirm">
      <div class="dialog-span-fixed">
        <div>
          <svg-icon :icon-class="!icon ? 'exclamation' : icon"></svg-icon>
        </div>
        <div class="dialog-span-content"><span v-html="confirmMsg"></span></div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="childDialogClick">
            {{ buttonMsg ? $t("MESSAGE.CONFIRMBUTTONTEXT1"):$t("MESSAGE.CONFIRMBUTTONTEXT") }}
          </button>
        </span>
      </template>
    </el-dialog>
    
    <el-dialog v-model="dialogMobileVisible" :append-to-body="true" width="90%" :before-close="childDialogClick" :show-close="false" center class="d_confirm">
      <div class="dialog-span-fixed">
        <div class="dialog-span-content"><span v-html="confirmMsg"></span></div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="childDialogClick">
            {{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}
          </button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, watch, getCurrentInstance } from 'vue'

export default {
  name: "ConfirmBoxs",
  props: {
    centerDialogVisible: Boolean,
    icon: String,
    confirmMsg: String,
    buttonMsg: Boolean,
  },
  emits: ['setConfirmFlag'],
  setup(props, { emit }) {
    const { appContext } = getCurrentInstance()
    const dialogVisible = ref(false)
    const dialogMobileVisible = ref(false)
    
    // 获取全局属性
    const objBaseInfo = appContext.config.globalProperties.$objBaseInfo || {}
    const notice = objBaseInfo.notice || ""

    const childDialogClick = () => {
      dialogVisible.value = false
      dialogMobileVisible.value = false
      emit("setConfirmFlag", false)
    }

    watch(() => props.centerDialogVisible, (newVal) => {
      const channelId = objBaseInfo.channelId || 'WEB'
      
      if (channelId == "WEB") {
        dialogVisible.value = newVal
      } else {
        dialogMobileVisible.value = newVal
      }
    })

    return {
      dialogVisible,
      dialogMobileVisible,
      childDialogClick,
      notice
    }
  }
}
</script>

<style lang="stylus" scoped>
@media screen and (max-width: 960px) {
  .dialog-span-fixed{
    display: block;
    .dialog-span-content{
      margin-left: 1rem;
      text-align: center;
      padding: 2rem 2rem;
      span {
        word-break: break-word;
      }
    }
  }
  .btn_dialog {
    margin: 1rem;
    padding: 0.2rem 10rem;
    border-radius: 1rem;
    height: 4rem;
  }
  :deep(.el-dialog__header) {
    display: none;
  }
  .d_confirm {
    margin-top: 25vh !important;
    :deep(.el-dialog__body) {
      padding: 2rem 2rem 1rem;
    }
    :deep(.el-dialog__footer) {
      padding: 0 0 1rem;
    }
    :deep(.el-dialog) {
      border-radius: 16px;
    }
  }
}
@media screen and (min-width: 961px) {
  .dialog-span-fixed{
    display: flex;
    .dialog-span-content{
      margin-left: 1rem;
      span {
        word-break: break-word;
      }
    }
  }
}
</style>